import React from 'react';
import styled from 'styled-components';

const StyledH1 = styled.h1`
  font-size: 20px;
  font-weight: bold;
  position: relative;
  color: #333;
`;

interface Props {
  children: any;
  isWide: boolean;
}

export const InquiryHeaderTitle = (props: Props) => {
  const { children, isWide } = props;

  return isWide ? <h1>{children}</h1> : <StyledH1>{children}</StyledH1>;
};
